import http from '../utils/http';

import {
  getJobsFromSAPUrl,
  importJobFromSAPUrl,
  linkJobUrl,
  getJobsWithSameSerialNumberUrl,
} from '../constants/urls';

import { setFeedbackAction } from './feedback';

import {
  GET_SAP_JOBS,
  CLEAR_JOBS,
} from '../constants/actionTypes';

const getSapJobsAction = jobs => ({ type: GET_SAP_JOBS, payload: jobs})

const clearJobsAction = () => ({ type: CLEAR_JOBS })

export const getJobsFromSAP = searchObj =>
  async dispatch => {
    try {
      const { data: response } = await http.post(getJobsFromSAPUrl(), searchObj);

      dispatch(getSapJobsAction(response.data))
    } catch (e) {
      dispatch(setFeedbackAction(e.message));
    }
  }

export const importJob = (jobObj, searchObj = null) =>
  async dispatch => {
    try {
      await http.post(importJobFromSAPUrl(), jobObj);

      searchObj && dispatch(getJobsFromSAP(searchObj))
      dispatch(setFeedbackAction('success'))
    } catch (e) {
      dispatch(setFeedbackAction(e.message));
    }
  }

export const getJobsWithSameSerialNumber = id =>
  async dispatch => {
    try {
      const { data: response } = await http.get(getJobsWithSameSerialNumberUrl(id));
      return(response.data);
    } catch (e) {
      dispatch(setFeedbackAction(e.message));
    }
  }

export const linkJob = (id, selectedJob, searchObj) =>
  async dispatch => {
    try {
      await http.put(linkJobUrl(id), selectedJob);

      searchObj && dispatch(getJobsFromSAP(searchObj));
      dispatch(setFeedbackAction('success'));
    } catch(e) {
      dispatch(setFeedbackAction(e.message));
    }
  }

export const clearJobs = () => dispatch => dispatch(clearJobsAction());



// WEBPACK FOOTER //
// ./src/actions/importJob.js